import { Flex, Link, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, DisplayHeading, Eyebrow, Postmark } from '@/travo/components/ui/postmark';
import { ROUTES } from '@/travo/routes';
import { localizePath, useCopy, useLocale } from '@/travo/i18n';
import { PILL_BUTTON } from '@/travo/theme/constants';

/**
 * Catch-all page, prerendered to dist/404.html, dist/zh-tw/404.html, dist/ja/404.html, dist/ko/404.html and dist/th/404.html so Cloudflare Pages
 * answers unknown URLs with a real 404 instead of the home page. noindex, no canonical.
 */
const NotFoundPage = () => {
  const { notFound } = useCopy();
  const locale = useLocale();

  return (
    <>
      <title>{notFound.title}</title>
      <meta name="robots" content="noindex" />
      <main>
        <Container as="section" py={{ base: '80px', md: '120px' }}>
          <Flex direction="column" align="center" textAlign="center" gap="24px">
            <Postmark ring="RETURN TO SENDER · NO SUCH ADDRESS ·" big="404" w="160px" h="160px" color="rust" transform="rotate(-10deg)" />
            <Eyebrow>{notFound.eyebrow}</Eyebrow>
            <DisplayHeading as="h1" fontSize={{ base: '38px', md: '56px' }}>
              {notFound.heading}
            </DisplayHeading>
            <Text maxW="28em" color="inkSoft">
              {notFound.body}
            </Text>
            <Link asChild {...PILL_BUTTON}>
              <RouterLink to={localizePath(locale, ROUTES.home)}>{notFound.cta}</RouterLink>
            </Link>
          </Flex>
        </Container>
      </main>
    </>
  );
};

export default NotFoundPage;
